import React from 'react';
import { newCareersDict } from '@common/const/catalog';
import { Grid } from '@cp/ds/src/components/grid';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CareerId } from '@common/const/catalog/career';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { useRouter } from '@cp/shared/router';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { ClientType } from '@common/model/client/clientType';
// import { CurrentUserType, useCurrentUser } from '@cp/entities/currentUser';
import { coreCareerApi } from '@cp/entities/career';
import { useIsMobile } from '@cp/ds/src/hooks';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { CareerButton } from 'src/app/shared/components/careerButton';
import { useModal } from 'src/shared/modalProvider';
import { CLIENT_TYPE_MODAL_NAME } from 'src/app/shared/components/modals/clientType/const';
import { useEmployerPreFilterRegistration } from 'src/features/registration/model/preFilter';
import { CatalogCareerListProps } from './types';

export const ITEM_SPACING_MOBILE = 7;
export const ITEM_SPACING_DESKTOP = 20;

export const CatalogCareerList: React.FC<CatalogCareerListProps> = ({ sx, itemType = CatalogItemType.Resume, enableLinks }) => {
  const isMobile = useIsMobile();
  // const user = useCurrentUser();
  const router = useRouter();
  const routeResolver = useClientWebResolver();
  const { openModal } = useModal();
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const items = Object.entries({ ...careerDictionary, ...(!isMobile && newCareersDict) }).map(
    ([careerId, careerViewModel]) => [Number(careerId), careerViewModel] as const,
  );
  const runEmployerPreFilterRegistration = useEmployerPreFilterRegistration();

  return (
    <Grid
      container
      spacing={{ xs: `${ITEM_SPACING_MOBILE}px`, md: `${ITEM_SPACING_DESKTOP}px` }}
      sx={mergeSx(
        {
          position: 'relative',
          zIndex: 1,
          pb: 4.5,
          width: '100%',
        },
        sx,
      )}
    >
      {items.map(([careerId, careerViewModel]) => {
        if (!careerViewModel) {
          return null;
        }

        const url =
          enableLinks && CareerId[careerId]
            ? String(
                routeResolver.resolve({
                  page: ClientWebPage.Catalog,
                  pageProps: { catalogType: itemType, careerId },
                }),
              )
            : undefined;
        return (
          <Grid item key={careerId} lg={2} sm={4} xs={6}>
            <Link href={url} sx={{ textDecoration: 'none' }}>
              <CareerButton
                careerId={careerId}
                label={careerViewModel.translation.namePlural}
                onClick={
                  'isActive' in careerViewModel && !careerViewModel.isActive
                    ? undefined
                    : () => {
                        openModal(CLIENT_TYPE_MODAL_NAME, {
                          careerId,
                          onClientTypeSelected: (clientType) => {
                            const catalogType = clientTypeToSuitableCatalogItemType(clientType);
                            // eslint-disable-next-line no-unused-expressions
                            if (clientType === ClientType.Employer) {
                              runEmployerPreFilterRegistration({ careerId });
                            } else {
                              router.navigate(
                                routeResolver.resolve({
                                  page: ClientWebPage.Catalog,
                                  pageProps: { catalogType, careerId },
                                }),
                              );
                            }
                          },
                        });
                      }
                }
                // onClick={
                //   'isActive' in careerViewModel && !careerViewModel.isActive
                //     ? undefined
                //     : (e) => {
                //         if (user.type === CurrentUserType.Guest) {
                //           e.preventDefault();
                //         }
                //         openModal(CLIENT_TYPE_MODAL_NAME, {
                //           careerId,
                //           onClientTypeSelected: (clientType: ClientType) => {
                //             const catalogType = clientTypeToSuitableCatalogItemType(clientType);
                //             router.navigate(clientResolver.resolve({ page: ClientWebPage.Catalog, pageProps: { catalogType, careerId } }));
                //           },
                //         });
                //       }
                // }
              />
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};
